// https://m3.material.io/styles/color/roles
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.defaultTheme = void 0;
    const defaultBreakpoints = {
        xs: 320,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        "2xl": 1536,
    };
    exports.defaultTheme = {
        themes: {
            base: {
                boxShadow: "0 0 0 2px var(--mindbreeze-colors-secondary)",
                // foreground color (font)
                colors: {
                    primary: "#222",
                    onPrimary: "white",
                    onPrimaryFixed: "#fec800",
                    secondary: "#fec800",
                    onSecondary: "black",
                    tertiary: "#0052a7",
                    onTertiary: "white",
                    outline: "#595959", // borders on surface containers or primary and secondary container
                    outlineVariant: "#e5e7eb", // lighter outline 
                    surface: "white", // background 
                    onSurface: "black",
                    surfaceComponent: "#f3f3f6", // ui components background on surface (button, chat message)
                    onSurfaceComponent: "black",
                    surfaceContainer: "#e5e7eb", // workplace the navigation sidebar
                    onSurfaceContainer: "black",
                    onSurfaceContainerVariant: "#898888",
                    titleText: "black", // TODO: for titles like facet names, result title, ...
                    text: "black",
                    textDisabled: "#ccc",
                    textAdditional: "#595959", // Metadata display
                    textAdditionalVariant: "#e5e7eb", // e.g. Sources found 
                    error: "#b94a48",
                    onError: "white",
                    errorContainer: "#FFDAD6",
                    onErrorContainer: "#7D2B25"
                },
                padding: {},
                margin: {},
                typography: {
                    fontFamily: {
                        default: "\"Roboto\", Arial, Helvetica, sans-serif",
                        heading: { var: "typography.fontFamily.default" },
                        code: "Monaco, Menlo, Consolas, \"Courier New\", monospace",
                        pre: { var: "typography.fontFamily.code" },
                        em: { var: "typography.fontFamily.default" },
                        quote: { var: "typography.fontFamily.default" },
                    },
                },
                textAlign: {},
                border: {
                    width: "1px",
                    color: "#ddd",
                    style: "solid",
                },
                borderRadius: {
                    default: "0",
                    "extra-small": "0.125rem",
                    small: "0.25rem",
                    "medium-small": "0.375rem",
                    standard: "0",
                    large: "0.75rem",
                    pill: "62.4375rem",
                    circle: "50%",
                },
                cursor: {},
            },
        },
        breakpoints: defaultBreakpoints,
        resources: {
            imgBasePath: "../img/v2"
        },
        icons: {
            "on-primary-logo": {
                imageBaseLocation: "Mindbreeze-Logo-NEG.svg",
                width: "257px",
                height: "34px",
            },
            "primary-logo": {
                imageBaseLocation: "Mindbreeze-Logo-NEG.svg",
                width: "257px",
                height: "34px",
            },
            "assistant-avatar": {
                themeable: true,
                html: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M12.4403 28C5.58209 28 0 22.4224 0 15.5605C0 8.69865 5.58209 3.11359 12.4403 3.11359C13.3209 3.11359 14.2313 3.21812 15.1343 3.41225C15.5373 3.50185 15.791 3.89759 15.7015 4.30079C15.6119 4.70399 15.2164 4.95785 14.8134 4.86825C14.0149 4.68905 13.2164 4.59945 12.4478 4.59945C6.41045 4.59945 1.5 9.51252 1.5 15.5531C1.5 21.5936 6.41045 26.5067 12.4478 26.5067C18.4851 26.5067 23.3955 21.5936 23.3955 15.5531C23.3955 14.7765 23.306 13.9776 23.1269 13.1861C23.0373 12.7829 23.291 12.3872 23.694 12.2976C24.097 12.208 24.4925 12.4619 24.5821 12.8651C24.7836 13.7685 24.8806 14.672 24.8806 15.5605C24.8806 22.4224 19.2985 28.0075 12.4403 28.0075V28Z" fill="#fec800"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1641 4.64427L19.3582 0.2912C19.3209 0.1344 19.1492 0 18.9477 0C18.7462 0 18.5746 0.1344 18.5298 0.336L17.7462 4.60693C17.2836 6.63787 16.5373 7.38453 14.5447 7.84L10.2238 8.63893C10.0373 8.6912 9.90295 8.85547 9.90295 9.05707C9.90295 9.25867 10.0373 9.4304 10.2388 9.4752L14.5074 10.2592C16.5373 10.7221 17.2836 11.4688 17.7388 13.4624L18.5447 17.8155C18.5821 17.9723 18.7537 18.1067 18.9552 18.1067C19.1567 18.1067 19.3283 17.9723 19.3731 17.7707L20.1567 13.4997C20.6194 11.4688 21.3656 10.7221 23.3582 10.2667L27.7089 9.46027C27.8656 9.42293 28 9.2512 28 9.0496C28 8.848 27.8656 8.67627 27.6641 8.63147L23.3955 7.84747C21.3582 7.38453 20.6194 6.63787 20.1641 4.64427Z" fill="#fec800"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9627 15.4187L10.5597 13.2459C10.5448 13.1712 10.4552 13.0965 10.3508 13.0965C10.2463 13.0965 10.1642 13.1637 10.1418 13.2608L9.74628 15.3963C9.51494 16.4117 9.1418 16.7851 8.14926 17.0165L5.98509 17.4123C5.88807 17.4347 5.82837 17.5243 5.82837 17.6213C5.82837 17.7184 5.89553 17.808 5.99255 17.8304L8.12688 18.2261C9.1418 18.4576 9.51494 18.8309 9.74628 19.824L10.1493 21.9968C10.1642 22.0715 10.2537 22.1461 10.3582 22.1461C10.4627 22.1461 10.5448 22.0789 10.5672 21.9819L10.9627 19.8464C11.194 18.8309 11.5672 18.4576 12.5597 18.2261L14.7314 17.8229C14.8134 17.808 14.8806 17.7184 14.8806 17.6139C14.8806 17.5093 14.8134 17.4272 14.7164 17.4048L12.5821 17.0091C11.5672 16.7776 11.194 16.4043 10.9627 15.4112V15.4187Z" fill="#fec800"/>
                </svg>`,
            },
            "chat-input-send": {
                themeable: false,
                html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1.2em" height="1.2em">
                  <path fill="#9ca3af" d="M27.71 4.29a1 1 0 0 0-1.05-.23l-22 8a1 1 0 0 0 0 1.87l8.59 3.43L19.59 11L21 12.41l-6.37 6.37l3.44 8.59A1 1 0 0 0 19 28a1 1 0 0 0 .92-.66l8-22a1 1 0 0 0-.21-1.05Z"></path>
                </svg>`,
            },
            "close-x-icon": {
                themeable: true,
                html: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0.942814L11.0572 0L6 5.05738L0.942814 0L0 0.942814L5.05719 6L0 11.0572L0.942814 12L6 6.94281L11.0572 12L12 11.0572L6.94281 6L12 0.942814Z" fill="black"/>
                </svg>`
            },
            "arrow-left": {
                themeable: true,
                html: `<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 6 10">
                  <path d="M0,5c0-.1163.0489-.2326.1465-.3214L5.1465.1332c.1954-.1776.5117-.1776.707,0,.1953.1776.1954.4652,0,.6427L1.207,5l4.6465,4.2241c.1954.1776.1954.4652,0,.6427-.1954.1775-.5117.1776-.707,0L.1465,5.3214C.0489,5.2326,0,5.1163,0,5Z" fill="#555756"/>
                </svg>`
            },
            "arrow-right": {
                themeable: true,
                html: `<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 6 10">
                  <path d="M6,5c0,.1163-.0489.2326-.1465.3214L.8535,9.8668c-.1954.1776-.5117.1776-.707,0-.1953-.1776-.1954-.4652,0-.6427l4.6465-4.2241L.1465.7759C-.0488.5982-.0488.3106.1465.1331.3419-.0443.6583-.0444.8535.1331l5,4.5454c.0976.0888.1465.2051.1465.3214h0Z" fill="#555756"/>
                </svg>`
            },
            "data-source-default-icon": {
                themeable: true,
                html: `<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 61.0669 60.9306">
              <path d="M29.3419.0226c25.258-.9375,40.7117,27.5024,26.0118,48.162-12.8008,17.9905-40.0529,16.6888-51.1681-2.3378C-7.4238,25.974,6.4571.872,29.3419.0226ZM28.6516,7.1039c.8747-1.0538-1.57-1.7771-2.078-1.0077-.5993.9075,1.3808.8519,1.6671,1.4739.0716.3256-.9401.4464-1.0637.6503l-.0506,1.1197-.6529-1.1909c-1.0339.0297-2.1323.2746-3.1444.0619-.672-.3798-.1178-1.0517-.2123-1.212l-.7282-.5895-3.5919,1.5098c-.0089.144-.0488.2449.1416.1926.5681-.156,1.1921-.7218,1.8852-.8595.4001-.0795.7835.0134,1.1647-.1504l.669.9163c-.6802-.0606-1.5222-.0762-2.0087.4572l.1788.6614c-.5399-.3587-.9864-.941-1.6904-.9801-.8981-.0499-1.4981.4329-2.2224.8763-3.1347,1.9192-5.9288,4.8569-7.8642,7.9654.4098.3594.7575.5462.7041,1.1815l.4571-.1998c.3714.1805.1227.6885.1953.8099.0569.0951,1.5808.9282,1.8786,1.1761.4538.3777,1.0341.8809.3521,1.3581l-.6994-.501c-.289.2234-.1253.8072.0207,1.0915.0884.1722.2256.1163.2326.1275.0149.0239-.2187.3331-.2606.4988-.2469.9766-.3049,3.6394.3596,4.43.188.2236.4673.2355.4941.2677.0391.047.0215.3858.0944.5668.5957,1.4794,1.8449,1.6162,2.55,2.5301.3283.4254.3781.9885.6029,1.4292.2621.5139.8616,1.2514,1.0893,1.7576.1861.4139-.0565.5141.0188.6787.1527.3338.8604.5275,1.0516.7891.1504.2058.232,1.0168.3079,1.0652l.2964.0064c-.1044-1.7861-1.6251-3.027-2.0304-4.7257,1.0395-.0725.8008.4408,1.0363,1.0974.317.884,1.7141,1.8766,2.2368,2.8453.079.1464.0425.3728.1005.456.0365.0524.3076.1093.4365.224.2759.2457.6901.6457.866.9631.5015.9049.1458,1.9955,1.0638,2.6955.4428.3377,3.2175,1.8278,3.6558,1.8305.507.0032.9474-.3488,1.6025-.1793.4959.1283.8521.827,1.2027,1.1335.5519.4825,1.7121.9278,2.4271.6696.1725.5724.6084,1.4437,1.0125,1.8853.0967.1057,1.1555.9843,1.2283,1.0168.1566.0699.2613.0067.3989-.0555.4317,1.2622,1.6439,1.3926,1.5269-.2043-.5634.0781-1,.2242-1.4738-.2019-.2758-.248-1.05-1.6097-.6615-1.8835.791.0739.3851-.931.1795-1.3938-.0917-.2065-.6696-1.0516-.852-1.0822-.0824-.0138-.3118.1992-.5933.2042-.3297.0059-.4744-.175-.7636-.2151l-.0061.2943-.6041.0103c.0837-.513.0801-1.0438.2318-1.546.1866-.6176,1.3805-2.0297.0234-2.057-1.5548-.0313-1.1149,1.507-1.8888,1.9187-.441.2346-1.6781.121-2.0753-.1434-.3241-.2157-.8115-1.1161-.9421-1.4964-.4456-1.2974.0532-2.2354-.0304-3.5248-.0118-.1827-.1991-.448-.1444-.5711.019-.0427.5639-.6885.602-.7154.2194-.1551.5571-.0279.7216-.2973l-.1552-.3037c.5232.0896,1.1871-.2202,1.6689-.1973.4057.0192.8956.617,1.2698.131l-.0929-.747c.1626-.0146.1251.2204.2435.3136.3773.2967.6728-.175.9232-.1744.0639.0002,1.1083.3118,1.2263.3618.2162.0918.4353.3775.6192.3934.3853.0334.4313-.5656.8498.3727.1535.3441.604,2.6438,1.3229,2.1437.298-.3081.0992-2.6679-.0295-2.7774-.3408-.2899-.9056-.02-.6641-1.0702.2845-1.2373,2.1932-.9914,2.6986-2.4839.1016-.2999-.1298-.5071.3233-.6897l-.0078-.2389-.5031-.2818c.0136-.6022.1806-.9204.4173-1.4548.3517-.0315.4394.3167.8061.1502.4869-.221.1392-.6642.3507-.8646.2907-.2756.7569-.2872,1.1029-.4298.2069-.0852.3478-.3252.6753-.2878-.1726-1.2755.5108-1.1348,1.3173-1.579.2064-.1137.6283-.51.7005-.5399.3837-.1589,1.0224-.0359,1.1985-.6137.1091-.358-.3372-1.1161-.7695-1.1229.1179-.2127.6012-.0339.7665-.3006.252-.4067-.4281-.5676-.7331-.5738-.802-.0163-1.473.5682-2.016,1.0782-.0043-1.3751,2.3136-1.7278,3.3666-1.8151.7229-.0599,1.2034-.0473,1.8032.386.3226-.3298.504-.6774.9435-.8904.6908-.3348,1.4496-.1185,1.2577-1.2711-.0293-.1201-.4471-.1365-.6192-.3155-.2002-.2082-.173-.6427-.2944-.7239-.0642-.0429-.2084.077-.2851.0389-.0323-.0161-.0259-.2021-.211-.2334-.4398-.0743-.7626.3142-1.3328-.2095-.3403-.3125-.323-.9304-.5266-1.3021-.1267-.2312-.4365-.4089-.596-.6232-.2345-.3152-.3068-.7467-.6749-.9573-.269-.046-.5536.6439-.7515.7545-.1033.0578-.3017-.021-.456.0385-.1835.0707-.3057.2681-.426.3022-.3587.1019-.6919-.4826-1.1466-.3926.2074-.6414.0259-1.1881-.5556-1.526-.7279-.423-2.6496-1.0651-3.4547-.9083-.8155.1588-.0181,1.2386-.0722,1.6498-.0395.2995-.4933.6777-.4874.9399.0095.4262,1.1035.5853.999,1.296-.0886.6024-1.2562.9345-1.3861,1.3647-.2272.7528.6315,1.2553.4402,1.5551-1.8916,1.6489-1.8386-1.556-2.6564-2.0221-.5079-.2895-1.057-.0168-1.1613-.0618-.1459-.0629-.5615-.4925-.8724-.6481-.9503-.4757-1.931-.5934-2.9844-.5207.0601-.5294-.2281-1.0776-.8138-1.0166.1742-.4662.1319-1.0485.2812-1.4969.0398-.1193,1.0531-1.6507,1.1404-1.7044.2043-.1257.826-.0158,1.1462-.073,1.1649-.2079,1.2548-1.8037,2.005-1.9643.5396-.1155,1.2577.7814,1.8382.2191.3256-.4248-.1158-.8838-.0935-1.005.0546-.2975.358-.2881-.0342-.817-.374-.5044-1.0868-.2891-1.5005.0855l.152.2531-1.1211,1.1163c-.5794.0587-.6906-1.1875-.8784-1.3054-.3243-.2036-.6952.3917-.7502.3917-.0794,0-.9492-.9357-1.3716-.7106ZM39.9303,44.7992c.0335-.357.025-.842-.4315-.7958-.3793.0384-1.8877,1.1278-2.0945,1.4715-.1137.1891-.1668.4307-.222.6432l-.9097-.3023.3974,3.6985c-.1373,1.2918-2.8943,2.4705-1.2028,3.6816-.2172.8075-.9097,1.3753-.5143,2.2726,5.3626-.8997,10.1679-3.5769,13.9151-7.4682.0035-.126-1.6316-.479-1.8627-.6515-.1133-.0846-.1168-.5106-.3655-.7759-.1173-.1251-1.9377-1.3729-2.0597-1.4033-.604-.1503-1.2765.4253-1.4055.4002-.1403-.0273-.5439-.3787-.7388-.4826-.2811-.1499-1.5811-.8631-1.7622-.872-.3802-.0188-.5066.4018-.7434.5841Z"/>
            </svg>`
            },
            "scroll-to-bottom-icon": {
                themeable: false,
                html: `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="#D8DADA"/>
            <path d="M14.305 22.1658C13.8983 21.715 13.8983 20.9842 14.305 20.5335C14.7117 20.0827 15.371 20.0827 15.7776 20.5335L20 25.2135L24.2224 20.5335C24.629 20.0827 25.2883 20.0827 25.695 20.5335C26.1017 20.9842 26.1017 21.715 25.695 22.1658L20.7363 27.6619C20.3297 28.1127 19.6703 28.1127 19.2637 27.6619L14.305 22.1658ZM14.305 13.9703C13.8983 13.5196 13.8983 12.7888 14.305 12.3381C14.7117 11.8873 15.371 11.8873 15.7776 12.3381L20 17.0181L24.2224 12.3381C24.629 11.8873 25.2883 11.8873 25.695 12.3381C26.1017 12.7888 26.1017 13.5196 25.695 13.9703L20.7363 19.4665C20.3297 19.9173 19.6703 19.9173 19.2637 19.4665L14.305 13.9703Z" fill="#878988"/>
            </svg>`
            },
            "exclamation": {
                themeable: true,
                html: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" class="text-center" fill="none" viewBox="0 0 6 16">
              <path id="Icon_awesome-exclamation" data-name="Icon awesome-exclamation" d="M6.1,13.431a2.487,2.487,0,1,1-2.487-2.487A2.49,2.49,0,0,1,6.1,13.431ZM1.413.783,1.836,9.24a.746.746,0,0,0,.745.709H4.644a.746.746,0,0,0,.745-.709L5.812.783A.746.746,0,0,0,5.066,0H2.158A.746.746,0,0,0,1.413.783Z" transform="translate(-1.125)" fill="#dc3545">
              </path>
            </svg>`
            },
            "pen-to-square": {
                themeable: true,
                html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
      </svg>`
            },
            "pen-to-square2": {
                themeable: true,
                html: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <g clip-path="url(#clip0_103_15)">
            <path d="M16.3082 8.36644C15.889 8.36644 15.5477 8.70778 15.5477 9.12699V15.8868C15.547 16.2129 15.2817 16.4783 14.9562 16.479H2.1128C1.7867 16.4783 1.52131 16.2129 1.52097 15.8875V3.04291C1.52131 2.71679 1.7867 2.45137 2.11246 2.45104H8.87234C9.29152 2.45104 9.63283 2.1097 9.63283 1.69048C9.63283 1.27127 9.29152 0.929932 8.87234 0.929932H2.11212C0.948614 0.930878 0.00101398 1.87863 0 3.04258V15.8875C0.00101398 17.0507 0.948614 17.9987 2.11246 18.0001H14.9562C16.1194 17.9987 17.0673 17.0507 17.0687 15.8875V9.12699C17.0687 8.70778 16.7274 8.36644 16.3082 8.36644Z" fill="black" />
            <path d="M17.4814 1.78774L16.2106 0.516837C15.5188 -0.172392 14.3933 -0.172392 13.7014 0.517513L5.26309 8.95619C5.00824 9.21133 4.85973 9.55003 4.84459 9.90921L4.76502 11.738L4.76367 11.8014C4.76435 12.5923 5.40728 13.2354 6.25855 13.2354H6.2622L8.08852 13.1555C8.44895 13.1409 8.78796 12.9917 9.04308 12.7362L17.482 4.29722C18.1732 3.60502 18.1726 2.47926 17.4814 1.78774ZM7.99084 11.637L6.28735 11.7116L6.3392 10.0321L12.498 3.87205L14.1266 5.50078L7.99084 11.637ZM16.406 3.22136L15.2019 4.42526L13.5733 2.79653L14.7774 1.59331C14.8758 1.49359 15.0381 1.49494 15.1352 1.59297L16.406 2.86387C16.505 2.96257 16.5044 3.123 16.406 3.22136Z" fill="black" />
        </g>
        <defs>
          <clipPath id="clip0_103_15">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>`
            },
            "drop-down-arrow": {
                themeable: true,
                html: `<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.50001 5C4.41864 5 4.33719 4.96742 4.27506 4.90233L1.09325 1.56902C0.968918 1.43877 0.968918 1.22785 1.09325 1.09769C1.21758 0.967521 1.41891 0.967438 1.54316 1.09769L4.50001 4.19534L7.45687 1.09769C7.5812 0.967438 7.78253 0.967438 7.90678 1.09769C8.03103 1.22794 8.03111 1.43885 7.90678 1.56902L4.72497 4.90233C4.66284 4.96742 4.58139 5 4.50001 5Z" fill="black" stroke="black"/>
            </svg>`
            },
            "copy": {
                themeable: true,
                class: "icon-copy",
                private: true
            },
            "refresh": {
                themeable: true,
                class: "icon-refresh",
                private: true
            },
            "info-sign": {
                themeable: true,
                class: "icon-info-sign",
                private: true
            },
            "angle-up": {
                themeable: true,
                class: "icon-angle-up",
                private: true
            },
            "angle-down": {
                themeable: true,
                class: "icon-angle-down",
                private: true
            }
        },
        baseFonts: [
            {
                fontFamily: "FontAwesome",
                src: [
                    {
                        url: "font/fontawesome-webfont.eot?v=3.2.1"
                    },
                    {
                        url: "font/fontawesome-webfont.eot?#iefix&v=3.2.1",
                        format: "embedded-opentype"
                    },
                    {
                        url: "font/fontawesome-webfont.woff?v=3.2.1",
                        format: "woff"
                    },
                    {
                        url: "font/fontawesome-webfont.ttf?v=3.2.1",
                        format: "truetype"
                    },
                    {
                        url: "font/fontawesome-webfont.svg#fontawesomeregular?v=3.2.1",
                        format: "svg"
                    }
                ]
            }
        ],
        "modules": {
            "basic.card": {
                "height": "100%",
                "mb-mod-card": {
                    "height": "100%"
                },
                "cardBorder": {
                    "height": "100%",
                    "border": {
                        "width": "2px",
                        "color": "#e7e7e7",
                        "style": "solid",
                        "radius": {
                            "var": "borderRadius.extraSmall"
                        }
                    },
                    "overflowY": "auto",
                    "borderRadius": "3px",
                    "backgroundColor": {
                        "var": "colors.surface"
                    }
                },
                "cardHeader": {
                    "padding": "16px 16px 8px",
                    "backgroundColor": {
                        "var": "colors.surface"
                    }
                },
                "cardBody": {
                    "padding": "8px 16px 0px"
                },
                "cardTitle": {
                    "fontWeight": {
                        "var": "typographyfontWeight.title"
                    },
                    "color": {
                        "var": "colors.primary"
                    },
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading1"
                        }
                    }
                },
                "cardTitle h1": {
                    "margin": "0",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading1"
                        }
                    }
                },
                "cardTitle h2": {
                    "margin": "0",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading2"
                        }
                    }
                },
                "cardTitle h3": {
                    "margin": "0",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading3"
                        }
                    }
                },
                "cardTitle h4": {
                    "margin": "0",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading4"
                        }
                    }
                },
                "cardTitle h5": {
                    "margin": "0",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading5"
                        }
                    }
                },
                "cardTitle h6": {
                    "margin": "0",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading6"
                        }
                    }
                },
                "cardSubtitle": {
                    "color": {
                        "var": "colors.primary"
                    },
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.heading3"
                        }
                    }
                },
                "cardFooter": {
                    "padding": "16px 16px 16px"
                },
                "cardAction": {
                    "margin": "10px 0 0 0 "
                }
            },
            "basic.resultform": {
                "resultFormField": {
                    "padding": "8px",
                    "margin": "0",
                    "border": {
                        "width": "0px",
                        "color": "rgba(0,0,0,0) rgba(0,0,0,0) #888 #888;",
                        "style": "solid"
                    }
                },
                "fieldTitle": {
                    "color": "#000",
                    "typography": {
                        "fontSize": "13px",
                        "fontWeight": "900"
                    }
                },
                "fieldContent": {}
            },
            "basic.resultlist": {
                "resultlistHeader": {
                    "textAlign": "left",
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.base"
                        },
                        "fontWeight": "bold"
                    }
                },
                "resultlistContent tr td": {
                    "padding": "5px 0",
                    "border": {
                        "width": "0 0 1px 0",
                        "color": "#d4d4d4",
                        "style": "solid"
                    },
                    "typography": {
                        "fontSize": {
                            "var": "typography.fontSize.base"
                        }
                    },
                    "cursor": "pointer"
                },
                "resultlistContent > tr:hover": {
                    "backgroundColor": "#f4f4f4"
                }
            },
            "basic.userinput": {
                "mbUserInput": {}
            }
        },
        widgets: {
            chat: {
                autoScroll: false,
                showScrollToBottom: true, //show scroll to bottom button
                showMessageOnTop: true, //show new user's message on top of the page
                header: {
                    isFullWidth: false,
                    paddingTop: "38px",
                    action: {
                        passiveColor: { var: "colors.surfaceComponent" },
                        clickedColor: { var: "colors.surfaceContainer" },
                        border: {
                            color: { var: "border.color" },
                        }
                    }
                },
                message: {
                    base: {
                        maxLines: 0,
                        borderColor: "",
                        borderWidth: { var: "border.width" },
                        borderStyle: { var: "border.style" },
                        backgroundColor: { var: "colors.surfaceComponent" },
                        showAvatarIcon: true,
                        defaultOrientation: "left",
                        fontFamily: { var: "fontFamily.default" },
                        messageGap: "20px",
                        citation: {
                            link: {
                                color: { var: 'colors.tertiary' }
                            }
                        },
                        code: {
                            backgroundColor: "#f9f9f9",
                            color: { var: "colors.onSurfaceComponent" },
                            border: {
                                color: "#dadada",
                                width: "1px",
                                style: "solid",
                                radius: "10px"
                            },
                        }
                    },
                    user: {
                        transparent: true,
                        color: { var: "colors.onSurfaceComponent" },
                        orientation: "right",
                        avatarWidth: "18px",
                        avatarHeight: "18px",
                        bubblePadding: "10px",
                        minBubbleWidth: "40%",
                        borderRadius: "8px"
                    },
                    assistant: {
                        backgroundColor: { var: "colors.surfaceComponent" },
                        color: { var: "colors.onSurfaceComponent" },
                        borderColor: { var: "colors.outlineVariant" },
                        borderWidth: { var: "border.width" },
                        borderStyle: { var: "border.style" },
                        borderRadius: "10px",
                        hideLeftAccentBorder: false,
                        avatarWidth: "24px",
                        avatarHeight: "24px",
                        fontFamily: { var: "fontFamily.default" },
                        maxBubbleWidth: "90%",
                        minBubbleWidth: "70%",
                        bubblePadding: "0px",
                    },
                },
                input: {
                    textInput: {
                        forceFocus: true,
                        color: { var: "colors.onSurfaceComponent" },
                        backgroundColor: { var: "colors.surfaceComponent" },
                        borderRadius: { var: "borderRadius.large" },
                        border: {
                            color: { var: "colors.outlineVariant" },
                            width: { var: "border.width" },
                            style: { var: "border.style" },
                        },
                        boxShadow: { var: "boxShadow" },
                        fontFamily: { var: "fontFamily.default" },
                        focus: {
                            border: {
                                color: { var: "colors.secondary" },
                                width: { var: "border.width" },
                                style: { var: "border.style" },
                            }
                        },
                        maxInputWidth: "75%"
                    },
                },
            },
            "chat[xs]": {
                header: {
                    isFullWidth: true,
                    action: {}
                },
                message: {
                    base: {
                        maxLines: 0,
                        messageGap: "10px"
                    },
                    user: {
                        showAvatarIcon: false,
                        minBubbleWidth: "90%",
                        maxBubbleWidth: "100%"
                    },
                    assistant: {
                        showAvatarIcon: false,
                        maxBubbleWidth: "100%",
                    },
                },
                input: {
                    textInput: {
                        maxInputWidth: "100%"
                    }
                }
            },
            "chat[sm]": {
                header: {
                    isFullWidth: true,
                    action: {}
                },
                message: {
                    user: {
                        showAvatarIcon: false,
                        minBubbleWidth: "90%",
                        maxBubbleWidth: "100%"
                    },
                    assistant: {
                        showAvatarIcon: false,
                        maxBubbleWidth: "100%",
                    },
                },
            },
            "chat[md]": {
                header: {
                    isFullWidth: true,
                    action: {}
                },
                message: {
                    base: {
                        maxLines: 0,
                    },
                    user: {
                        showAvatarIcon: false,
                        orientation: "right",
                        minBubbleWidth: "80%",
                        maxBubbleWidth: "100%"
                    },
                    assistant: {
                        showAvatarIcon: false,
                        maxBubbleWidth: "100%",
                    },
                },
                input: {
                    textInput: {
                        maxInputWidth: "100%"
                    }
                }
            },
            "chat[lg]": {
                message: {
                    user: {
                        showAvatarIcon: false,
                        minBubbleWidth: "60%",
                        maxBubbleWidth: "95%",
                    },
                }
            },
            "chat[xl]": {
                message: {
                    user: {
                        maxBubbleWidth: "90%",
                    },
                    assistant: {},
                },
            },
            "chat[2xl]": {
                message: {
                    base: {
                        maxLines: 8,
                    },
                    user: {
                        maxBubbleWidth: "95%",
                    },
                    assistant: {},
                },
            },
            "chat[groklike 2xl]": {},
            "chat[groklike]": {
                autoScroll: false,
                showScrollToBottom: false,
                message: {
                    base: {
                        maxLines: 12,
                    },
                },
            },
            "resultsources[xs]": {
                sources: {
                    showIndex: false,
                }
            },
            answer: {
                actions: {
                    color: { var: "colors.onSurfaceContainerVariant" },
                    hoverColor: { var: "colors.onSurfaceContainerVariant" }
                }
            },
            resultsources: {
                sources: {
                    showIndex: true,
                    autoCollapseNonFocused: true,
                    color: { var: "colors.textDisabled" },
                    fontSize: "15px",
                    defaulIconColor: { var: "colors.textTitle" },
                    hideDataSourceIcon: false,
                    sourceIndexMinWidth: "25px"
                },
                result: {
                    base: {
                        borderRadius: { var: "borderRadius.small" },
                        border: {
                            color: "#999",
                            width: "2px",
                            style: { var: "border.style" },
                        },
                        hideLeftAccentBorder: true,
                        closeBtnColor: { var: "colors.onSurface" },
                        backgroundColor: "#fff"
                    },
                    actions: {
                        color: { var: "colors.tertiary" },
                        hoverColor: { var: "colors.tertiary" },
                        font: {
                            family: { var: "fontFamily.default" },
                            size: "14px",
                            weight: "700"
                        },
                        separator: {
                            color: { var: "colors.secondary" },
                            width: "1px",
                            height: "12px"
                        }
                    },
                    title: {
                        color: { var: "colors.onSecondary" },
                        font: {
                            family: { var: "fontFamily.default" },
                            size: "16px",
                            weight: "700"
                        },
                        lineHeight: "22px"
                    },
                    snippet: {
                        maxLines: "10",
                        highlightMaxChars: "512",
                        border: {
                            color: { var: "border.color" },
                            width: { var: "border.width" },
                            style: { var: "border.style" },
                        },
                        summary: {
                            color: { var: "textAdditional" },
                            font: {
                                size: "10px",
                                weight: "normal",
                                family: { var: "fontFamily.default" },
                            },
                        },
                        property: {
                            label: {
                                color: { var: "colors.outline" },
                                font: {
                                    size: "10px",
                                    weight: "700",
                                    family: { var: "fontFamily.default" },
                                },
                            },
                            value: {
                                color: { var: "colors.outline" },
                                font: {
                                    size: "10px",
                                    weight: "normal",
                                    family: { var: "fontFamily.default" },
                                },
                            }
                        }
                    }
                }
            }
        }
    };
});
